/* eslint-disable vue/max-len */

/** 语言 */
const lang = {
  $当前语言: 'English',
  中文: 'Chinese',
  英文: 'English',
};

/** 菜单 */
const menu = {
  选款管理: 'Choose Style Manage',
  AIGC选款列表: 'AIGC Choose Style List',
};

/** 表单 */
const form = {
  请选择: 'Select',
  请输入: 'Enter',
  确定: 'Confirm',
  确认: 'Confirm',
  取消: 'Cancel',
  提交: 'Submit',
  删除: 'Delete',
  警告: 'Warn',
  成功: 'Success',
  失败: 'Fail',
  状态: 'State',
  提示: 'Tip',
  至: 'To',
  只看我的: 'My',
  查询: 'Query',
  重置: 'Reset',
  展开: 'Expand',
  收起: 'Retract',
  导入: 'Import',
  导出: 'Export',
  开始日期: 'Start date',
  结束日期: 'End Date',
  粘贴或拖放: 'Paste or drag',
  文件上传: 'File upload',
  '请粘贴文件，或者把文件拖入输入框': 'Please paste the file or drag the file into the input box',
  待上传文件: 'File to be uploaded',
};

export default {
  ...lang,
  ...menu,
  ...form,
  品类: 'Category',
  导入外部数据: 'Import external data',
  批量标记: 'Batch mark',
  今日各版本未选任务款数: 'Number of tasks not selected in each version today',
  选款人: 'Selection person',
  选款日期: 'Selection date',
  灵感来源: 'Source of inspiration',
  国家站点: 'National site',
  跑图渠道: 'Running channel',
  数据来源: 'Data sources',
  选图人: 'Picking person',
  选图时间: 'Picking time',
  全部: 'All',
  未选择: 'Unselected',
  可用: 'Available',
  不可用: 'Unavailable',
  版本: 'Version',
  备注: 'Remark',
  选图记录: 'Image selection record',
  标记: 'Mark',
  全选: 'Check all',
  选择结果: 'Result',
  请选择选图结果: 'Please select the image selection result',
  确认标记: 'Confirmation mark',
  建议价格: 'Price',
  建议风格: 'Style',
  建议类目: 'Category',
  建议波段: 'Band',
  建议店铺: 'Store',
  建议国家: 'Country',
  建议印花: 'Printing',
  上传图片: 'Pictures',
  新增店铺: 'Add Store',
  图: 'picture',
  请选择要标记的图片: 'Please select the image to be marked',
  请填写完整要标记的图片信息: 'Please fill in the complete image information to be marked',
  标记成功: 'Marking successful',
  店铺名称: 'Store name',
  店铺编码: 'Store code',
  店铺名称不能为空: 'The store name cannot be empty',
  店铺编码不能为空: 'The store code cannot be empty',
  新增店铺成功: 'Successfully added store',
  提交成功: 'Submitted successfully',
  质检结果: 'Quality inspection results',
  请选择质检结果: 'Please select the quality inspection result',
  请选择图片以便定位问题: 'Please select an image to locate the issue',
  已选: 'Selected',
  问题分类: 'Question classification',
  请选择问题分类: 'Please select the problem category',
  修图建议: 'Suggestions for image editing',
  通过: 'Pass',
  不通过: 'Fail',
  SPU编码: 'SPU Code',
  数据: 'Data',
  数量限制: 'Quantity limit',
  格式限制: 'Format limit',
  大小限制: 'Size Limit',
  详情: 'Detail',
  附件: 'Attachment',
  选款结果: 'Selection result',
  请上传文件: 'Please upload the file',
  导入数据: 'Import Data',
  导入失败: 'Import failed',
  '导入成功，部分导入失败': 'Import successful, partial import failed',
  导入成功: 'Import successful',
  将文件拖到此处或: 'Drag the file here or',
  点击上传: 'Click to upload',
  '严禁上传包含色情、暴力、反动等相关违法信息的文件。': 'It is strictly prohibited to upload files containing illegal information such as pornography, violence, and reactionary content.',
  模板下载: 'Template Download',
  导出结果: 'Export Results',
  质检人: 'Quality inspector',
  质检日期: 'QC date',
  返修日期: 'Repair date',
  QC结果: 'QC results',
  图包上传人: 'Image transmission',
  已返修: 'Repaired',
  未返修: 'Unrepaired',
  主图: 'Host graph',
  问题图片: 'Problematic images',
  返修完成: 'Repair completed',
  操作: 'Operate',
  标记返修完成: 'Mark repair',
  '输入SPU搜索，可单个或者多个': 'Enter SPU search, which can be single or multiple',
  '确定标记为已返修?': 'Are you sure to mark it as repaired?',
  名称: 'Name',
};
